/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import React from "react";

const initState = "week"; // day, week, month

const TableViewGanttOptionsContext = React.createContext(initState);
export const useGanttOptions = () =>
    React.useContext(TableViewGanttOptionsContext);

const TableViewGanttOptionsSwitchContext = React.createContext(() => {});
export const useSwitchGanttOptions = () =>
    React.useContext(TableViewGanttOptionsSwitchContext);

export default ({ children }) => {
    const [value, setValue] = React.useState(() => initState);
    return (
        <TableViewGanttOptionsContext.Provider value={value}>
            <TableViewGanttOptionsSwitchContext.Provider
                value={(v) => {
                    setValue(v);
                }}
            >
                {children}
            </TableViewGanttOptionsSwitchContext.Provider>
        </TableViewGanttOptionsContext.Provider>
    );
};
